import './index.css';
import React from 'react';
import { createRoot } from 'react-dom/client'; // Importez createRoot de react-dom/client
import App from './App';
import { AuthProvider } from "./context/AuthContext";

// Récupérez l'élément root
const container = document.getElementById('root');

// Utilisez createRoot pour monter l'application
const root = createRoot(container);

root.render(
  <React.StrictMode>
     <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);



